var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hello zoom-box nv-full nv-pos-a",staticStyle:{"background-color":"#fff"}})
}
var staticRenderFns = []

export { render, staticRenderFns }